import store from "../store";
import { PublicClientApplication } from "@azure/msal-browser";

let msal = null;

export async function initialize() {
	const msalConfig = {
		auth: {
			clientId: "581e89a4-82c8-4117-b43d-03d4b566053b",
			authority:
				"https://login.microsoftonline.com/66e853de-ece3-44dd-9d66-ee6bdf4159d4",
			redirectUri: "https://dev.barkeep.distell.co.za/login",
		},
		cache: {
			cacheLocation: "localStorage",
			storeAuthStateInCookie: false,
		},
	};
	msal = await new PublicClientApplication(msalConfig);
}

export async function signIn() {
	await msal
		.loginPopup({})
		.then(() => {
			const myAccounts = msal.getAllAccounts();
			store.dispatch("setUser", {
				name: myAccounts[0].name,
				username: myAccounts[0].username,
			});
		})
		.catch((error) => {
			console.error(`error during authentication: ${error}`);
		});
}

export function signOut() {
	store.dispatch("setUser", null);
	if (!msal) return;
	msal.logoutRedirect({
		onRedirectNavigate: () => {
			return false;
		},
	});
}

export function isAuthenticated() {
	if (!msal) return false;
	const accounts = msal.getAllAccounts();
	return accounts.length > 0;
}

export function getUser() {
	if (!msal) return null;
	const accounts = msal.getAllAccounts();
	if (accounts.length == 0) {
		return null;
	}
	return accounts[0];
}
